import React, { useState, useEffect, useContext } from "react";

import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";

import DataTable from "./TeachersList";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import {PopUpContext} from "../../contexts/popUpContext";
import Filter from "./TeacherFilter";
import {YearContext} from "../../contexts/yearContext";

const Teachers = () => {
  const [data, setData] = useState([]);
  const { entryYear } = useContext(YearContext);
  const { togglePopUp, popUp } = useContext(PopUpContext);

  useEffect(() => {
    const ac = new AbortController();

    requestData( {entry_year_id: entryYear});

    return () => ac.abort();
  }, [entryYear, popUp]);

  const requestData = async (p = {}) => {
    try {
      let {
        keyword: teacher_name,
        teacher_phone,
        faculty_id,
        gender_id,
        aria_id,
        user_status,
        page,
      } = p;

      let query = "teachers?";

      if (page) query += `&page=${page}`;
      if (teacher_name) query += `&teacher_name=${teacher_name}`;
      if (teacher_phone) query += `&teacher_phone=${teacher_phone}`;
      if (gender_id) query += `&gender_id=${gender_id}`;
      if (faculty_id) query += `&faculty_id=${faculty_id}`;
      if (aria_id) query += `&aria_id=${aria_id}`;
      if (user_status) query += `&user_status=${user_status}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
      });
    } catch ({ response }) {
      setData(response);
    }
  };


  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={lbl.TeachersList} />
        </div>
        <div className="center-content">
          <Filter query={requestData} hasFilter={true} />
        </div>
        <div className="left-content">
          <MainButton
              type="add"
              title={lbl.AddTeacher}
              handleClick={() => togglePopUp({ form: "teacher-form" })}
          />
        </div>
      </div>
      <div className="main-content-body pagination">
        <DataTable data={data?.data}/>
      </div>
    </div>
  );
};

export default Teachers;
